"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialValues = exports.getValidator = void 0;
const lodash_1 = __importDefault(require("lodash"));
const create_validator_1 = __importDefault(require("../create-validator"));
const getValidator = (schema, step) => (values) => {
    const schemaValidator = (0, create_validator_1.default)(schema, step);
    return schemaValidator(values);
};
exports.getValidator = getValidator;
const getInitialValues = (schema, step) => (0, lodash_1.default)(schema)
    .pickBy((definition) => {
    const hasInitialValue = lodash_1.default.has(definition, 'initialValue');
    if (lodash_1.default.isEmpty(step))
        return hasInitialValue;
    if (lodash_1.default.isArray(definition.step))
        return lodash_1.default.includes(definition.step, step) && hasInitialValue;
    return definition.step === step && hasInitialValue;
})
    .pickBy((value) => lodash_1.default.has(value, 'initialValue'))
    .mapValues('initialValue')
    .value();
exports.getInitialValues = getInitialValues;
const packageSchemaForFormik = (schema, step) => ({
    initialValues: (0, exports.getInitialValues)(schema),
    initialValuesForCurrentStep: (0, exports.getInitialValues)(schema, step),
    validate: (0, exports.getValidator)(schema),
    validateCurrentStep: (0, exports.getValidator)(schema, step),
});
exports.default = packageSchemaForFormik;
